"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPercentageRange = exports.formatTwoDecimals = exports.formatValue = exports.formatSnakeCase = void 0;

require("core-js/modules/es6.regexp.split.js");

require("core-js/modules/es6.object.to-string.js");

require("core-js/modules/es6.regexp.to-string.js");

require("core-js/modules/es6.regexp.replace.js");

require("core-js/modules/es6.number.is-nan.js");

require("core-js/modules/es6.number.constructor.js");

var _lowerCase2 = _interopRequireDefault(require("lodash/lowerCase"));

var _replace2 = _interopRequireDefault(require("lodash/replace"));

var _capitalize2 = _interopRequireDefault(require("lodash/capitalize"));

var _isNil2 = _interopRequireDefault(require("lodash/isNil"));

var _currency = _interopRequireDefault(require("currency.js"));

var _drivers = require("../constants/drivers");

/**
 * Get the number of decimals that the given number has.
 * E.g.
 *  0.005 => 3.
 *  1997 => 0.
 *  1.23 => 2.
 * @param {Number} value
 * @returns {Number} the number of decimal places the given value has.
 */
var countDecimals = function countDecimals(value) {
  if (Math.floor(value.valueOf()) === value.valueOf()) {
    return 0;
  }

  return value.toString().split('.')[1].length || 0;
};
/**
 *
 * @param {Currency} c The currency.js object
 * @param {*} settings The currency.js settings merged with it's default settings.
 * @returns {String} the formatted currency.
 */


var fractionalFormatter = function fractionalFormatter(c, settings) {
  var pattern = settings.pattern,
      negativePattern = settings.negativePattern,
      symbol = settings.symbol,
      separator = settings.separator,
      decimal = settings.decimal,
      groups = settings.groups;
  var split = "".concat(c).replace(/^-/, '').split('.');
  var dollars = split[0];
  var valuePrecision = countDecimals(c.value);
  var currencyCents = c.cents();
  var cents = '';

  if (valuePrecision < 3) {
    return (0, _currency.default)(c.value, {
      pattern: pattern,
      negativePattern: negativePattern,
      symbol: symbol,
      decimal: decimal,
      groups: groups,
      precision: 2
    }).format();
  }

  if (currencyCents % 10 !== 0) {
    cents = split === null || split === void 0 ? void 0 : split[1];
  } else if (currencyCents >= 100) {
    cents = "".concat(currencyCents).substring(0, 2);
  } else {
    cents = "0".concat(currencyCents).substring(0, 3);
  }

  return (c.value >= 0 ? pattern : negativePattern).replace('!', symbol).replace('#', dollars.replace(groups, "$1".concat(separator)) + (cents ? decimal + cents : ''));
};
/**
 * Format a string from snake case to sentence case
 * (e.g. 'average_set_of_discounts' -> 'Average set of discounts').
 *
 * @param {string} value - The string value to be formatted.
 * @return {string} - Formatted string in sentence case.
 */


var formatSnakeCase = function formatSnakeCase(value) {
  if ((0, _isNil2.default)(value) || value === '') {
    return null;
  }

  return (0, _capitalize2.default)((0, _replace2.default)((0, _lowerCase2.default)(value), /_/g, ' '));
};
/**
 * Driver value formatter.
 *
 * @param {string} value - The string value to be formatted.
 * @param {format} [format] - The format type.
 * @param {boolean} shouldDisplayEmptyAsNA - If true, will return 'N/A' for empty values
 * @return {string} - Formatted string.
 */


exports.formatSnakeCase = formatSnakeCase;

var formatValue = function formatValue(value, format) {
  var shouldDisplayEmptyAsNA = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if ((0, _isNil2.default)(value) || value === '') {
    if (shouldDisplayEmptyAsNA) {
      return 'N/A';
    }

    return null;
  }

  var curr = (0, _currency.default)(value);

  switch (format) {
    case _drivers.FORMATS.CURRENCY:
      return (0, _currency.default)(value, {
        precision: 0
      }).format();

    case _drivers.FORMATS.CURRENCY_FRACTIONAL:
      return curr.value !== 0 ? (0, _currency.default)(value, {
        precision: 3,
        format: fractionalFormatter
      }).format() : (0, _currency.default)(value, {
        precision: 0
      }).format();

    case _drivers.FORMATS.CURRENCY_WITH_CENTS:
      return curr.value !== 0 ? curr.format() : (0, _currency.default)(value, {
        precision: 0
      }).format();

    case _drivers.FORMATS.DECIMAL:
      return (0, _currency.default)(value, {
        symbol: ''
      }).format();

    case _drivers.FORMATS.NUMBER:
      return (0, _currency.default)(value, {
        precision: 0,
        symbol: ''
      }).format();

    case _drivers.FORMATS.PERCENT:
      return (0, _currency.default)(value, {
        symbol: '%',
        pattern: '#!',
        precision: 0
      }).format();

    case _drivers.FORMATS.PERCENT_WITH_DECIMAL:
      return (0, _currency.default)(value, {
        symbol: '%',
        pattern: '#!'
      }).format();

    case _drivers.FORMATS.STRING:
    default:
      return value;
  }
};
/**
 * Format a value to have a maximum of 2 decimals.
 * @param {string} value - The string value to be formatted.
 * @return {string} - Formatted string.
 */


exports.formatValue = formatValue;

var formatTwoDecimals = function formatTwoDecimals(value) {
  return !(0, _isNil2.default)(value) ? formatValue(value, _drivers.FORMATS.DECIMAL) : 'N/A';
};
/**
 * Provided a min & max number, format it as a percentage range.
 *
 * @param {number} min - The minimum value
 * @param {number} max - The maximum value
 * @param {boolean} [respectZero=false] - Whether to respect zero as valid value
 *  @example
 *  loans verticals often require non-`null` values for fields like `min_variable_apr`
 *
 * @return {string} - The formatted percentage range
 */


exports.formatTwoDecimals = formatTwoDecimals;

var getPercentageRange = function getPercentageRange(min, max) {
  var respectZero = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var parsedMin = parseFloat(min);
  var parsedMax = parseFloat(max);
  var hasMin = respectZero ? !Number.isNaN(parsedMin) : !!parsedMin;
  var hasMax = respectZero ? !Number.isNaN(parsedMax) : !!parsedMax;
  var formattedMin = formatTwoDecimals(parsedMin);
  var formattedMax = formatTwoDecimals(parsedMax);

  if (hasMin && hasMax) {
    return "".concat(formattedMin, "-").concat(formattedMax, "%");
  }

  if (hasMin) {
    return "".concat(formattedMin, "%");
  }

  if (hasMax) {
    return "".concat(formattedMax, "%");
  }

  return null;
};

exports.getPercentageRange = getPercentageRange;